/**
 * src/main.tsx — Application entry point.
 * Auth is handled inside App via AuthContext (no MsalProvider needed here).
 */
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { installAuthFetch } from "./auth/authFetch";
import "@fontsource-variable/nunito";
import "./index.css";

// Attache le Bearer MSAL à tout appel fetch() vers /api/* ou /ts/* — avant le premier rendu,
// pour couvrir tous les appels réseau de l'application (cf. src/auth/authFetch.ts).
installAuthFetch();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
